import { render, staticRenderFns } from "./das-ord.vue?vue&type=template&id=eb4b12a6&scoped=true"
import script from "./das-ord.vue?vue&type=script&lang=js"
export * from "./das-ord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4b12a6",
  null
  
)

export default component.exports